(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(30441);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var utils_wagmi__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36380);
/* harmony import */ var _views_Swap__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3753);



var SwapPage = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_views_Swap__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {});
};
SwapPage.chains = utils_wagmi__WEBPACK_IMPORTED_MODULE_1__/* .CHAIN_IDS */ .vo;
/* harmony default export */ __webpack_exports__["default"] = (SwapPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,2077,4990,2632,8082,9858,1576,3325,3753,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);